<script setup lang="ts">
import NextVisitInstructionsAddEditForm from "@/components/models/patient/forms/PatientNextVisitInstructionsForm.vue";
import { useNextVisit } from "@/composables/models/patient/useNextVisit";
import { usePatient } from "@/composables/models/patient/usePatient";
import { useAbility } from "@casl/vue";
import { definePage } from "unplugin-vue-router/runtime";
import { computed } from "vue";
import { useRoute } from "vue-router";

definePage({
  meta: {
    title: "generic.action.editEntity",
    titleParams: { entity: "generic.entity.nextVisitInstruction" },
    checkPrivileges: () => {
      const { can } = useAbility();
      return can($permActions.READ, $permSubjects.PATIENT__INSTRUCTIONFORNEXTVISIT);
    },
  },
});

const route = useRoute();
const routeParams = route.params as { id: string };

const { data: nextVisitInstructions, isLoading: isNextVisitInstructionsLoading } = useNextVisit({
  id: routeParams.id,
});
const { data: patient, isLoading: isPatientLoading } = usePatient({
  id: computed(() => nextVisitInstructions.value?.patient ?? ""),
  enabled: computed(() => !!nextVisitInstructions.value?.patient),
});
</script>

<template>
  <v-skeleton-loader :loading="isNextVisitInstructionsLoading || isPatientLoading">
    <next-visit-instructions-add-edit-form
      v-if="patient"
      :patient="patient"
      :next-visit-instructions="nextVisitInstructions"
    />
  </v-skeleton-loader>
</template>

<style scoped></style>
